import React, { useContext } from "react"
import Grid from "../grid"
import { UIContext } from "../layout"
import usePlatformBlocks from "../hooks/usePlatformBlocks"
import withAnimation from "../../../design-system/util/withAnimation"
import { FadeInBottom } from "../../shared/keyframes.style"

import {
  OverlayStyle,
  Container,
  Title as _Title,
  PlatformBlocks as _PlatformBlocks,
} from "./mappedin-layers.banner.style"

const Title = withAnimation(_Title)
const PlatformBlocks = withAnimation(_PlatformBlocks)

export default function LayersBanner() {
  const {
    state: { breakpoint },
  } = useContext(UIContext)

  const platformBlocks = usePlatformBlocks()

  return (
    <Container>
      <Grid
        addMargin={breakpoint !== "sm"}
        overlayStyle={breakpoint === "sm" ? OverlayStyle : null}
      >
        <PlatformBlocks
          fluid={platformBlocks.childImageSharp.fluid}
          animation={FadeInBottom}
        />
        <Title>
          Building a <span>Digital Mapping and Wayfinding Experience</span>
        </Title>
      </Grid>
    </Container>
  )
}
